import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SubscriptionStateService } from '../../service/subscription-state.service';
import { daysLeft } from '../../service/billing.util';

/** Topbar'da sakin, sürekli deneme göstergesi (spec 2026-09-24 §3.2). Kırmızı/kilit değildir. */
@Component({
    selector: 'app-trial-chip',
    standalone: true,
    imports: [RouterModule, TranslateModule],
    template: `
        @if (days() !== null) {
            <!-- Final inceleme M7: dar ekranda yalnız gün sayısı, sm ve üstünde tam metin; ad her zaman tam metin. -->
            <a routerLink="/subscription" class="trial-chip" data-testid="trial-chip" [attr.aria-label]="'COMMON.TRIAL.CHIP' | translate: { days: days() }">
                <i class="pi pi-clock" aria-hidden="true"></i>
                <span class="sm:hidden" aria-hidden="true" data-testid="trial-chip-compact">{{ days() }}</span>
                <span class="hidden sm:inline" aria-hidden="true" data-testid="trial-chip-full">{{ 'COMMON.TRIAL.CHIP' | translate: { days: days() } }}</span>
            </a>
        }
    `,
    styles: [
        `
            .trial-chip {
                display: inline-flex;
                align-items: center;
                gap: 0.4rem;
                padding: 0.3rem 0.75rem;
                margin-right: 0.5rem;
                border-radius: 999px;
                font-size: 0.8rem;
                white-space: nowrap;
                background: rgba(59, 130, 246, 0.1);
                border: 1px solid rgba(59, 130, 246, 0.4);
                color: #1e3a8a;
            }
            :host-context(.app-dark) .trial-chip {
                color: #bfdbfe;
            }
        `
    ]
})
export class TrialChipComponent {
    private state = inject(SubscriptionStateService);

    /** null = çip yok. Durum yüklenmemiş/hatalıysa gösterilmez. */
    readonly days = computed<number | null>(() => {
        if (!this.state.loaded() || this.state.statusFailed()) return null;
        const s = this.state.status();

        if (!s || this.state.normalizedStatus() !== 'Trial') return null;

        // Düzeltme turu 2: sunucu `trial.daysLeft`i negatif dönebilir; null (çip yok) korunur, sayı ise 0'da taban alınır.
        const raw = s.trial?.daysLeft ?? daysLeft(s.periodEnd);

        return raw === null ? null : Math.max(0, raw);
    });
}
